var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/phone-input/phone-input.tsx";
const _excluded = ["value", "onChange", "defaultCountryCode"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { parsePhoneNumber, AsYouType } from 'libphonenumber-js';
import React, { useState, useEffect } from 'react';
import Input from '../input/input';
import CountryCodeDropdown from './country-code-dropdown';

/** Internationalized phone input with country code picker. */
const PhoneInput = props => {
  const {
    value,
    onChange,
    defaultCountryCode = '1'
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [nationalNumber, setNationalNumber] = useState('');

  const handleChange = _ref => {
    let {
      target
    } = _ref;
    // HACK: AsYouType is not meant to be used this way. But it works!
    const asYouType = new AsYouType({
      defaultCallingCode: countryCode
    });
    const formatted = asYouType.input(target.value); // If the new value is the same as before, we might be backspacing,
    // so use the actual event value instead of the formatted value.

    if (formatted === nationalNumber && target.value !== nationalNumber) {
      setNationalNumber(target.value);
    } else {
      setNationalNumber(formatted);
    }
  }; // When the internal state changes, update the external state.


  useEffect(() => {
    if (onChange) {
      try {
        const opts = {
          defaultCallingCode: countryCode,
          extract: false
        };
        const result = parsePhoneNumber(nationalNumber, opts); // Throw if the number is invalid, but catch it below.
        // We'll only ever call `onChange` with a valid E164 string or `undefined`.

        if (!result.isPossible()) {
          throw result;
        }

        onChange(result.format('E.164'));
      } catch (e) {
        // The value returned is always a valid E164 string.
        // If it's not valid, it'll return undefined.
        onChange(undefined);
      }
    }
  }, [countryCode, nationalNumber]);
  useEffect(() => {
    handleChange({
      target: {
        value: nationalNumber
      }
    });
  }, [countryCode, nationalNumber]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    onChange: handleChange,
    value: nationalNumber,
    prepend: /*#__PURE__*/React.createElement(CountryCodeDropdown, {
      countryCode: countryCode,
      onChange: setCountryCode,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 9
      }
    })
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }));
};

export default PhoneInput;